import { styled } from '@classify/react-core-components/styles';
import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { translate } from '@openclassrooms/translations';
import CircleArrowIcon from './CircleArrowIcon';
import LearningStatus from './LearningStatus';
import { QUIZ_STATUSES } from '../../_constants/LearningStatuses';
interface Props {
  status: (typeof QUIZ_STATUSES)[number];
  color?: string;
  ariaHidden?: boolean;
}
const NotStartedIcon = styled(AssignmentTurnedInIcon)(({
  theme: {
    palette
  }
}) => ({
  width: 14,
  height: 14,
  color: palette.progress.completion.disabled.active
}));
const InProgressIcon = styled(RotateRightIcon)(({
  theme: {
    palette
  }
}) => ({
  width: 18,
  height: 18,
  color: palette.progress.event.completed
}));
const CanRetryIcon = styled(CircleArrowIcon)(({
  theme: {
    palette
  }
}) => ({
  width: 12,
  height: 12,
  color: palette.progress.event.awaitingFeedback
}));
const FailedIcon = styled(ClearIcon)(({
  theme: {
    palette
  }
}) => ({
  width: 14,
  height: 14,
  color: palette.progress.event.noShow
}));
const PassedIcon = styled(DoneIcon)(({
  theme: {
    palette
  }
}) => ({
  width: 14,
  height: 14,
  color: palette.progress.learningAsset.onPassed
}));
const getLearningStatusIcon = (color: string | undefined, ariaHidden: boolean) => ({
  'not started': <LearningStatus sx={{
    borderColor: 'progress.completion.disabled.active'
  }}>
      <NotStartedIcon aria-label={translate('courses.accessibility_labels.quiz.not_started')} aria-hidden={ariaHidden} />
    </LearningStatus>,
  'in progress': <LearningStatus sx={{
    borderColor: 'progress.event.completed'
  }}>
      <InProgressIcon aria-label={translate('courses.accessibility_labels.quiz.in_progress')} aria-hidden={ariaHidden} />
    </LearningStatus>,
  retry: <LearningStatus sx={{
    borderColor: 'progress.event.awaitingFeedback'
  }}>
      <CanRetryIcon aria-label={translate('courses.accessibility_labels.quiz.retry')} aria-hidden={ariaHidden} />
    </LearningStatus>,
  failed: <LearningStatus sx={{
    borderColor: 'progress.event.noShow'
  }}>
      <FailedIcon aria-label={translate('courses.accessibility_labels.quiz.failed')} aria-hidden={ariaHidden} />
    </LearningStatus>,
  passed: <LearningStatus sx={{
    borderColor: 'progress.learningAsset.background.passed',
    backgroundColor: 'progress.learningAsset.background.passed'
  }}>
      <PassedIcon aria-label={translate('courses.accessibility_labels.quiz.passed')} aria-hidden={ariaHidden} />
    </LearningStatus>,
  promotion: <LearningStatus sx={{
    borderColor: 'progress.completion.disabled.active'
  }}>
      <NotStartedIcon aria-label={translate('courses.accessibility_labels.quiz.not_started')} aria-hidden={ariaHidden} />
    </LearningStatus>
});
const QuizLearningStatus = ({
  status,
  color,
  ariaHidden = false
}: Props) => {
  const safeStatus = status || 'not started';
  const icons = getLearningStatusIcon(color, ariaHidden);
  return icons[safeStatus] || icons['not started'];
};
export default QuizLearningStatus;